<template>
  <!-- 질문35 -->
  <v-layout flex-fill column class="survey-type-10">
    <template v-if="step === 1">
      <div class="subheader">자신에게 해당되는 것에 표시해 주세요.</div>
      <div class="question">최근 가장 고민이 되거나 <br/>관심이 있는 주제를 3가지 선택해 주세요.</div>
      <div class="answer">
        <ToggleBtn :total="strArr.length"
                   minWidth="calc(50% - 16px)"
                   :str="strArr"
                   :multiple="multiple"
                   :max="3"
                   :answer="answerCd"
                   @selectBtn="selectedBtn"/>
      </div>
    </template>
    <template v-else>
      <div class="subheader">가능한 한 자세히 작성해 주세요. </div>
      <div class="question">고민되는 내용을<br>구체적으로 작성해 주세요.</div>
      <div class="answer flex-grow-0">
        <div class="answer-text answer-text-start">
          <span class="box" v-for="n in 3" :key="n">{{ answer[n - 1] }}</span>
        </div>
      </div>
      <div class="answer">
        <Textarea auto-grow :no-resize="false" rows="3" :value="value" height="auto" :counter="500"
                  :placeholder="'최대한 자세히 작성해보세요.'" @input="inputChanged"/>
      </div>

    </template>
  </v-layout>
</template>

<script>
import ToggleBtn from '@/components/btns/ToggleBtn'
import Textarea from '@/components/forms/Textarea'
import store from '../../store'

export default {
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    step: 1,
    value: null,
    strArr: [],
    answer: [],
    answerCd: [],
    multiple: true,
    inputVal: [],
    inputValIndex: 0,
    memberNo: 0
  }),
  components: {
    ToggleBtn,
    Textarea
  },
  mounted() {
    this.memberNo = this.$store.state.auth.authUser.userKey;
    this.getCodeList();
  },
  methods: {
    inputChanged(input) {
      // console.log("input : " + input)
      this.value = input;
      this.inputVal[3] = this.value;
      this.$emit('step10Selected', this.inputVal);
    },
    viewStep() {
      console.log("thisStep : " + this.step);
      return this.step;
    },
    selectedBtn(val) {
      console.log(val);
      this.$emit('emotionSelected', val);
    },
    changePrev(prevVal) {
      console.log("changePrev111 : " + this.step);
      this.answerCd = [];
      for (let j = 0; j < prevVal.length; j++) {
        if (j === 3) {
          this.value = prevVal[j];
        } else {
          for (let h = 0; h < this.strArr.length; h++) {
            if (this.strArr[h].cd === prevVal[j]) {
              this.answerCd.push(this.strArr[h].cd)
            }
          }
          this.$emit('emotionSelected', this.answerCd);
        }
      }
      this.step = 1;
      console.log("changePrev222 : " + this.step);
    },
    change(nextVal) {
      this.inputVal = nextVal;
      this.inputValIndex = nextVal.length;
      this.answer = [];
      if (nextVal.length > 0) {
        for (let i = 0; i < nextVal.length; i++) {
          if (i === 3) {
            this.value = nextVal[i];
          } else {
            for (let k = 0; k < this.strArr.length; k++) {
              if (this.strArr[k].cd === nextVal[i]) {
                this.answer.push(this.strArr[k].cdNm)
              }
            }
          }
        }
      }
      this.step = 2;
    },
    async getCodeList() {
      console.log("Step 10 - getCodeList");
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': 'ST006'}))
        .then(res => {
          if (res.success) {
            this.strArr = res.data;
            this.getStepLoadData('N');
          } else {
            console.log(res.msg)
            this.strArr = []
          }
        })
        .catch(error => {
          console.error(error)
          this.strArr = []
        })
        .finally(() => {
        })
    },
    async getStepLoadData(gubun) { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 10 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.reply != undefined && res.data.reply != null) {
              let getVal = res.data.reply.split('|');
              if (gubun === 'N') {
                this.change(getVal);
              } else {
                this.changePrev(getVal);
              }
            } else {
              if (gubun === 'P') {
                this.step = 1;
                this.getCodeList();
              }
            }
          } else {
            console.log(res.msg)
            this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          this.answer = [];
        })
        .finally(() => {
        })
    },
  }
}
</script>
